module.exports = __webpack_public_path__ + "img/token.c404d603.png";